module.exports = __webpack_public_path__ + "static/img/3-open.abcbce92.png";